import { DatePipe, PercentPipe } from "@angular/common";
import { Component, computed, inject, input } from "@angular/core";
import { PeriodDefinitionType } from "@models/map/market-filter.model";
import { SafePipe, ThousandizePipe } from "ev-core";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";
import { EstateAgentMarketShare } from "src/models/estate/IResidenceSaleInArea";
import { MarketSalesDataService } from "src/services/estate/market-sales-data.service";
import { MarketSalesStateService } from "src/services/estate/market-sales-state.service";

@Component({
    selector: "estate-agent-market-shares",
    imports: [ThousandizePipe, EvLogoLoaderComponent, DatePipe, SafePipe, PercentPipe],
    templateUrl: "./estate-agent-market-shares.component.html",
    styleUrl: "./estate-agent-market-shares.component.scss",
})
export class EstateAgentMarketSharesComponent {
    estateAgentMarketShares = input.required<EstateAgentMarketShare[]>();
    marketSalesDataService: MarketSalesDataService = inject(MarketSalesDataService);

    private readonly mapStateService = inject(MarketSalesStateService);

    filterForm = this.mapStateService.filterForm;
    periodType = PeriodDefinitionType;
    private readonly maxNumberOfTopMarketShares: number = 20;
    showSale: boolean = false;

    computedTimePeriod = computed(() => {
        let from = null;
        let to = null;
        if (this.filterForm().value().timePeriod.useFromToDate) {
            from = this.filterForm().value().timePeriod.fromDate;
            to = this.filterForm().value().timePeriod.toDate;
        } else {
            from = new Date();
            from.setHours(0, 0, 0, 0);
            from = new Date(from.setMonth(from.getMonth() - this.filterForm().value().timePeriod.numberOfMonthsToShow));
            to = new Date();
        }
        return { fromDate: from, toDate: to };
    });

    estateAgentMarketShareView = computed(() => {
       const vm: MarketSharesViewModel = {
            total: null,
            details: []
        };
        if(this.estateAgentMarketShares() && this.estateAgentMarketShares().length > 0) {
            vm.largestShare = Math.max(...this.estateAgentMarketShares().map(x => x.value));
            vm.total = this.estateAgentMarketShares().reduce((n, { value }) => n + value, 0);
            this.estateAgentMarketShares().forEach(x => {
                vm.details.push(this.convertToExtended(x, vm.total, vm.largestShare));
            })

            if (vm.details.length > this.maxNumberOfTopMarketShares) {
                const topMarketShares = vm.details.slice(0, 20);
                const bottom = vm.details.slice(20);

                const other: MarketSharesModel = {
                    value: bottom.reduce((n, { value }) => n + value, 0),
                    key: "Annet"
                }
                topMarketShares.push(this.convertToExtended(other, vm.total, vm.largestShare));
                vm.details = topMarketShares;
            }
        }
        return vm;
    })

       private convertToExtended(x: MarketSharesModel, total: number, largestShare: number): MarketSharesModelExtended {
        const marketShare: MarketSharesModelExtended = x;
        marketShare.percent = parseFloat((x.value / total).toFixed(3));
        const growFactor = total / largestShare;
        marketShare.stapleWidth = Math.round((100 * ((100) / (100 * total) * (x.value))) * (growFactor * (2/3)));
        return marketShare;
    }
}

export interface MarketSharesViewModel {
    total: number;
    largestShare?: number;
    details: MarketSharesModelExtended[];
}

export interface MarketSharesModelExtended extends MarketSharesModel {
    stapleWidth?: number;
    percent?: number;
}

export interface MarketSharesModel {
    key?: string;
    value?: number;
}
